import { render, staticRenderFns } from "./SubscriptionsRoute.vue?vue&type=template&id=5928b572&scoped=true&"
import script from "./SubscriptionsRoute.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsRoute.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionsRoute.vue?vue&type=style&index=0&id=5928b572&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5928b572",
  null
  
)

export default component.exports